import { Text } from "@radix-ui/themes";
import { AvgQaScoreFormatter } from "./AvgQaScoreFormatter";

const MIN_VALID_SCORE = 0;

export function AvgQuackMessageScoreFormatter({ value }: { value?: number }) {
  if (value == null || value < MIN_VALID_SCORE) {
    return (
      <Text color="gray" weight={"medium"} highContrast>
        No Score
      </Text>
    );
  }

  return <AvgQaScoreFormatter value={value} />;
}
